/*
import { inject, Signal } from '@angular/core';
import { MbscResource } from '@mobiscroll/angular';
import { RosterContent } from './types/roster-content';
import { MbscCalendarOptions } from '@mobiscroll/angular/dist/js/core/components/calendar/calendar';


-------- Abstraction idea --------

export interface RosterFeature {
  name: string;
  providers: [], //used for repositories
  masterMainComponent: TestComponent,
  calender: {
    eventComponent: EventComponent,
    resourceComponent: ResourceComponent,
    service: RosterCalendarService
  }
}

class EventRepository<T extends RosterContent = RosterContent> {
  loadEvents() {}
  createEvent() {}
  updateEvent() {}
  deleteEvent() {}
  deleteEvents() {}
}

class ResourceRepository<T extends MbscResource> {
  loadResources() {}
  loadResourceDetail() {}
}

class RosterCalendarService<CreateEvent, Event extends RosterContent = RosterContent> {
  eventRepository = inject(EventRepository<T>);
  resourceRepository = inject(ResourceRepository<T>);

  calendarConfig: Signal<MbscCalendarOptions>

  onInit()

  // events
  onCellDoubleClick()
  onDrop(event: CreateEvent) {

  }
  onEventDoubleClick()
  // ...
}

class RosterRegistry {
  private features: RosterFeature[] = inject(SOFTLINE_TOKEN_ROSTER_FEATURE);

  feature: { [key: string]: RosterFeature } = {};
}

// external module (e.g. garage, ticket)
function withGarageRoster(): RosterFeature {
  return [
    {
      provide: SOFTLINE_TOKEN_ROSTER_FEATURE,
      multi: true,
      useValue: {
        name: string;
        providers: [
          { provide: EventRepository, useClass: CustomEventRepository }
        ],
        masterMainComponent: TestComponent,
        calender: {
          eventComponent: EventComponent,
          resourceComponent: ResourceComponent,
          service: RosterCalendarService
        }
      }
    }
  ]
}


// app.config.ts
provideRosterModule(
  withGarageRoster(),
  withPmsRoster()
);


*/

import { InjectionToken, InputSignal, Provider, Type } from '@angular/core';
import { MbscCalendarEvent, MbscResource } from '@mobiscroll/angular';
import { SoftAppsModuleConfig } from '@softapps/core';
import { Dictionary } from '@softline/core';
import { ComponentType } from '@angular/cdk/portal';

export interface RosterEventComponent<T extends MbscCalendarEvent> {
  event: InputSignal<T>;
}

export interface RosterResourceComponent {
  resource: InputSignal<MbscResource>;
}

export interface RosterFeature<T extends MbscCalendarEvent = MbscCalendarEvent> {
  name: string;
  module?: Omit<SoftAppsModuleConfig, 'route'>;
  translations?: Dictionary<object>;
  providers: Provider[]; //used for repositories
  menuBar?: ComponentType<any>;
  menus?: {
    calendarEventContextMenu: ComponentType<any>;
  };
  sidebarWidth?: string;
  resourceFilterPlaceholder?: string;
  components: {
    eventComponent?: () => Promise<Type<RosterEventComponent<T>>>;
    calendarResourceComponent?: () => Promise<Type<RosterResourceComponent>>;
    resourceComponent: () => Promise<Type<any>>;
    resourceBottomComponent?: () => Promise<Type<any>>;
  };
  departmentHeadRequired?: boolean;
}

export const SOFTLINE_TOKEN_ROSTER_FEATURE = new InjectionToken<RosterFeature[]>(
  'SOFTLINE_TOKEN_ROSTER_FEATURE'
);

export const SOFTLINE_ROSTER_TIME_CONFIG = new InjectionToken<{
  startHour: number;
  endHour: number;
}>('SOFTLINE_ROSTER_TIME_CONFIG');
